import React, { FC } from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IProps {
  copy?: string;
}

export const Loading: FC<IProps> = ({ copy }) => {
  const { t: translateUi } = useTranslation("ui");
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: 300,
      }}
    >
      <CircularProgress
        sx={{
          color: "primary.main",
          my: 2,
        }}
      />
      <Box textAlign="center">
        <Typography variant="body1">
          {copy || translateUi("state.loading")}...
        </Typography>
      </Box>
    </Box>
  );
};
